import { SwiperSlide } from 'swiper/react'
import { A11y } from 'swiper'

import { useSlider } from 'components/slider/useSlider'
import { Navigation } from 'components/slider/navigation'
import { Preview } from 'components/slider/preview'
import { ScreenSize } from 'styles/mq'
import { SliderContainer, StyledSwiper } from 'components/slider/styled'
import { ActiveSlideImage, SlideImage, StyledContainer } from './styled'

const slideProps = {
  maximumWidth: 542,
  imagesPerView: 3,
  aspectRatio: '718 / 1012',
}

const slides = [
  {
    src: require('./assets/slider/Leaders_Ammosov.jpg'),
    activeSrc: require('./assets/slider/Leaders_Ammosov-RED.jpg'),
    title: 'Максим Аммосов',
    description:
      'В 1919 году занимался разведывательной работой в тылу белых войск своего противника Александра Колчака. После окончательного установления советской власти Аммосов активно вел переговоры в Москве и помог добиться автономии для региона. Позже вернулся уже в Якутскую АССР и занимал высокие должности внутри госаппарата, принимал участие в создании плана развития экономики и исследовании запасов полезных ископаемых республики.',
  },
  {
    src: require('./assets/slider/Leaders_Arzhakov.jpg'),
    activeSrc: require('./assets/slider/Leaders_Arzhakov-RED.jpg'),
    title: 'Степан Аржаков',
    description:
      'Один из основателей якутской автономии. Был соавтором Декларации прав и обязанностей трудящихся Якутской АССР вместе с Платоном Ойунским. Несколько лет в 1920-х возглавлял местные органы безопасности – наркомат внутренних дел и ГПУ. Позже – возглавил Совет народных комиссаров Якутской АССР.',
  },
  {
    src: require('./assets/slider/Leaders_Platon-Oyunsky.jpg'),
    activeSrc: require('./assets/slider/Leaders_Platon-Oyunsky-RED.jpg'),
    title: 'Платон Ойунский',
    description:
      'Писатель и один из основоположников саха-литературы. Ойунский был среди главных инициаторов создания автономии. В 1922 году его назначили первым руководителем ЯАССР. Позже – был депутатом Верховного совета СССР. В 1930-х начал выступать против советской политики "расшаманивания" в Сибири и связанных с ней репрессий. Скончался от туберкулеза будучи под арестом.',
  },
]

export const Slider = () => {
  const { swiper, setSlideIndex, openImageUrl, setOpenImageUrl, slide } =
    useSlider(slides)

  return (
    <StyledContainer>
      <SliderContainer>
        <StyledSwiper
          loop
          centeredSlides
          slidesPerView="auto"
          spaceBetween={8}
          onTransitionStart={s => setSlideIndex(s.realIndex)}
          onInit={s => {
            swiper.current = s
          }}
          modules={[A11y]}
          breakpoints={{
            [ScreenSize.MD]: {
              spaceBetween: 30,
              slidesPerView: slides.length,
            },
            [ScreenSize.LG]: {
              spaceBetween: 77,
              slidesPerView: slides.length,
            },
          }}
        >
          {slides.map((s, i) => (
            <SwiperSlide key={i}>
              <SlideImage
                {...slideProps}
                src={s.src}
                onClick={() => setOpenImageUrl(s.src)}
              />
              <ActiveSlideImage src={s.activeSrc} />
            </SwiperSlide>
          ))}
        </StyledSwiper>

        <Navigation
          title={slide.title}
          description={slide.description}
          note={slide.note}
          swiper={swiper}
          titleInNav
        />

        <Preview
          openImageUrl={openImageUrl}
          onClose={() => setOpenImageUrl('')}
        />
      </SliderContainer>
    </StyledContainer>
  )
}
